import CoingatePaymentForm from "@/modules/billing/coingate/CoingatePaymentForm.tsx";
import { linkDefaults } from "@/modules/billing/paymentMethodDefaults.tsx";
import type { LinkMethod } from "@/modules/billing/paymentMethods.ts";
import type { CoingateConfig } from "@warrenio/api-spec/spec.oats.gen";

export function makeCoingateLink(config: CoingateConfig) {
    return config.methods.map((method): LinkMethod => {
        const base = linkDefaults(config, method);
        return {
            ...base,
            PaymentForm: (props) => <CoingatePaymentForm {...props} method={method} config={config} />,
        };
    });
}
